import { render, staticRenderFns } from "./EnvironmentService.vue?vue&type=template&id=28cf71d4&scoped=true&"
import script from "./EnvironmentService.vue?vue&type=script&lang=js&"
export * from "./EnvironmentService.vue?vue&type=script&lang=js&"
import style0 from "./EnvironmentService.vue?vue&type=style&index=0&id=28cf71d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28cf71d4",
  null
  
)

component.options.__file = "EnvironmentService.vue"
export default component.exports